import { UpgradeComponent } from "@angular/upgrade/static";
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from "@angular/core";
import { Log } from '../../logs/log.model';
import { TemplateWithUsers } from "ng/src/app/templates/shared/template.model";

@Directive({
	selector: 'template-alert-container[selectedLog][template][config][singleEditAlert]'
})
export class TemplateAlertContainerComponent extends UpgradeComponent {
	@Input() selectedLog!: Log;
	@Input() template!: TemplateWithUsers;
	@Input() config!: any;
	@Input() singleEditAlert!: any;
	@Input() draftSaveMessage = "Saving Notification Settings Draft";
	@Input() publishSaveMessage = "Publishing Notification Settings";
	@Input() navigateHaltMessage = "You have made changes to your notification preferences without saving. Are you sure you want to leave?";
	
	@Output() selectedLogChange = new EventEmitter<Log>();
	
	constructor(
		elRef: ElementRef,
		injector: Injector
	) {
		super('alertBuilder', elRef, injector);
	}
	
}